import React, { useEffect, useRef, useState } from "react";
import { putAxiosResponse, getAxiosResponse, logoutFunc } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { useDispatch } from 'react-redux'
import $ from "jquery";
import { useNavigate } from 'react-router-dom';
import { updateRightModelStatus } from "../../redux/reducers/RightModelStatus";
import Constants from "../../Constants";
import { reduxLogout } from "../../redux/reducers/ContrastSlice";
import Cookies from 'universal-cookie';
import useLogOut from "../../services/customHook/UseLogout";
import { updateCustomerBootstrapData } from "../../redux/reducers/CustomerBootstrapDataSlice";


export default function UserTermAndConditions({termAndConditionsToAccept}) {

  const [disable, setDisabled] = useState(true)
  const [url, setUrl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const logOut = useLogOut();


  useEffect(() => {

    if(termAndConditionsToAccept){
        let finalUrl=`/termsAndConditions/` + termAndConditionsToAccept?.role?.value + `/content.htm`;
        getAxiosResponse(`${process.env.REACT_APP_BACKEND_SERVER}/download/secured/1.24${finalUrl}`).then(res=>{
            setUrl(res.data);
        });
        showModel();
    }

  }, [termAndConditionsToAccept])


  const logout = () => {
    hideModel()
    navigate("/logout")
  }

  const acceptTermAndCondition = () => {
    dispatch(updateRightModelStatus({ "status": false }))
    let data = termAndConditionsToAccept;
    let obj = {
      termsAndConditionsChecked: true, versionAccepted: data?.version,
      termsAndConditionsCheckedDate: data?.createdDate
    }
    putAxiosResponse(APIUrls.TERM_CONDITIONS + `/${data.id}.json`, obj).then((res) =>{
        if(res?.data?.code === 200){
            dispatch(updateCustomerBootstrapData({ type: "termsConditionsToAccept", value: null}));
        }
    })
    hideModel()
  }



  const showModel = () => {
    document.body.classList.add("modal-open");
    $(".right-modal").addClass("nodisplay")
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".sourceFrame").on("keydown", function (e) {
        if (e.key === Constants.TAB && e.shiftKey) {
          e.preventDefault();
          if($('#termAccept').prop('disabled')){
            $(".first-focus").trigger("focus");
          }
          else{
            $("#termAccept").trigger("focus");
          }
      }
      });
      $(document).on("keydown", function (e) {
       if (e.key === Constants.ESCAPE) {
            document.body.classList.add("modal-open");
        }
     });
    }, 500);
  };
 
  const handleKeyEditflow = (event) => {
    if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        $(".sourceFrame").trigger("focus");
      }
  };
  const handleKeyCancleTerm = (e) => {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === false) {
         e.preventDefault();
         if($('#termAccept').prop('disabled')){
           $(".sourceFrame").trigger("focus");
         }
         else{
          $("#termAccept").trigger("focus");
          }
        }
     }
   
  };

  const attachReadOnScroll = (event) => {
    let tcIframe = $("#tc-iframe")[0].contentWindow;
    let scrolledHeight = $(tcIframe).height() === $(tcIframe.document).innerHeight() ? $(tcIframe).height() : ($(tcIframe.document).innerHeight() - $(tcIframe).height());
    tcIframe.addEventListener('scroll', function (event) {
      if ((scrolledHeight - $(tcIframe).scrollTop()) < 50) {//50 pixels for error margin across browsers
        setDisabled(false)
      }
    }, false);
  };



  


  const hideModel = () => {
    document.body.classList.remove("modal-open");
    $(".right-modal").removeClass("nodisplay")

  };

  return (
    <div><div id="termsconditionmodel" className="terms-and-condition-model" aria-labelledby="termsCondition" aria-modal="true" role="dialog">
      <div className="inner-lightbox-panel pb-0">
        <div className="modal-header flex">
          <strong id="termsCondition">OPAL-Marketing Terms of Use</strong>
        </div>
        <div className="search-deptt-content padd-22 sourceFrame" tabIndex="0">         
          <iframe srcDoc={url} id="tc-iframe" aria-label="Terms and Conditions" allow="fullscreen" width="1000" height="500" onLoad={attachReadOnScroll} /> 
        </div>
        <div className="modal-footer modal-footer-border flex px-22">
          <button type="button" className="btn btn-bold first-focus" aria-label="Decline and Sign out"
           id="termCancel" onClick={logout}
           onKeyDown={(e) => handleKeyCancleTerm(e)}
           >Decline and Sign out</button>
          <button disabled={disable} onKeyDown={handleKeyEditflow} type="button" aria-label="Accept" onClick={acceptTermAndCondition} className="btn btn-bold active" id="termAccept">Accept</button>
        </div>
      </div>
    </div></div>
  )
}
